import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'sort' })
export class SortPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array)) return array;

    return array.sort((a, b) => {
      let fieldA = a[field];
      let fieldB = b[field];
      if (a[field] != undefined) fieldA = a[field].toLowerCase();
      if (b[field] != undefined) fieldB = b[field].toLowerCase();

      if (fieldA < fieldB) return -1;
      if (fieldA > fieldB) return 1;
      return 0;
    });
  }
}
